/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './dental-tooth-surface.reducer';

export const DentalToothSurfaceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dentalToothSurfaceEntity = useAppSelector(state => state.dentalToothSurface.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dentalToothSurfaceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.dentalToothSurface.detail.title">DentalToothSurface</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.dentalToothSurface.id">Id</Translate>
            </span>
          </dt>
          <dd>{dentalToothSurfaceEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.dentalToothSurface.active">Active</Translate>
            </span>
          </dt>
          <dd>{dentalToothSurfaceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.dentalToothSurface.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{dentalToothSurfaceEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.dentalToothSurface.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{dentalToothSurfaceEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.dentalToothSurface.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{dentalToothSurfaceEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.dentalToothSurface.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{dentalToothSurfaceEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dentalToothSurface.tooth">Tooth</Translate>
          </dt>
          <dd>{dentalToothSurfaceEntity.tooth ? dentalToothSurfaceEntity.tooth.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dentalToothSurface.surface">Surface</Translate>
          </dt>
          <dd>{dentalToothSurfaceEntity.surface ? dentalToothSurfaceEntity.surface.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/dental-tooth-surface" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/dental-tooth-surface/${dentalToothSurfaceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DentalToothSurfaceDetail;
